module.exports = __webpack_public_path__ + "static/img/purchase-plan.93aaffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/purchase-plan.jpg
// module id = bdls
// module chunks = 1